import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
const PaymentStatusHandler = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const token = queryParams.get('token')
    const appointmentId = queryParams.get('appointment_id')

    if (token && appointmentId) {
      const payload = {
        appointment_id: appointmentId,
        appointment_token: token,
        payment_flag: 1,
      }

      axios
        .post(`${secureLocalStorage.getItem("baseURL")}/api/change-payment-status`, payload)
        .then(() => {
          setStatus('success')
          setTimeout(() => {
            navigate('/appointments/upcoming-appointments-list', { replace: true })
          }, 2500)
        })
        .catch(() => {
          setStatus('error')
          setTimeout(() => {
            navigate('/appointments/upcoming-appointments-list', { replace: true })
          }, 2500)
        })
    } else {
      setStatus('error')
      setTimeout(() => {
        navigate('/appointments/upcoming-appointments-list', { replace: true })
      }, 2000)
    }
  }, [location.search, navigate])

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow p-4 text-center" style={{ width: '400px' }}>
        {status === 'loading' && (
          <>
            <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }} role="status"></div>
            <h5 className="fw-bold text-secondary">Processing Payment...</h5>
            <p className="text-muted">Please wait while we confirm your payment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="mb-3">
              <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '3rem' }}></i>
            </div>
            <h5 className="fw-bold text-success">Payment Successful!</h5>
            <p className="text-muted">Redirecting to your appointments...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="mb-3">
              <i className="bi bi-x-circle-fill text-danger" style={{ fontSize: '3rem' }}></i>
            </div>
            <h5 className="fw-bold text-danger">Payment Failed!</h5>
            <p className="text-muted">Redirecting to appointments...</p>
          </>
        )}
      </div>
    </div>
  )
}

export default PaymentStatusHandler